import type { CycleAudience } from '@/types/cycle-evaluation/CycleAudience';

import { api } from '@/api/api';

export default {
    async updateCycleAudience(cycleAudience: CycleAudience): Promise<CycleAudience> {
        const response = await api.put(`/cycleaudience/${cycleAudience.id}`, cycleAudience);

        return response.data;
    },

    async getCycleAudience(cycleAudienceId: string): Promise<CycleAudience> {
        const response = await api.get(`/cycleaudience/${cycleAudienceId}`);

        return response.data;
    },
};
